const expandableHeader = document.querySelectorAll('.expandable-header')
expandableHeader.forEach((header, index) => {
	let isExpanded = false
	header.addEventListener('click', () => {
		const faqAnswer = document.getElementById(`faq-answer-${index + 1}`)
		faqAnswer.classList.toggle('hidden')
		const icon = header.querySelector('svg')
		const path = icon.querySelector('path')
		if (isExpanded) {
			path.setAttribute('d', 'M12 6V12M12 12V18M12 12H18M12 12L6 12')
			isExpanded = false
		} else {
			path.setAttribute('d', 'M6 12H18')
			isExpanded = true
		}
	})
})

export default expandableHeader
